import * as mobx from "mobx";

// MobX 5 does not have the function makeObservable, MobX 6 does. This compiles against both.
export function makeObservable(target, annotations, options) {
  const mobx_ = mobx;
  if (mobx_.makeObservable) {
    return mobx_.makeObservable(target, annotations, options);
  }
  return target;
}

// Hide this in a function otherwise the reference to ".override" is inlined, and fails at load time.
function getOverride(x) {
  return x.override;
}

// MobX 5 does not have the decorator override, MobX 6 does. This compiles against both.
export const override = "override" in mobx ? getOverride(mobx) : mobx["action"] /*mobx.action*/;
//# sourceMappingURL=ConditionalMobx.js.map
